module.exports = __webpack_public_path__ + "static/media/car-driver.3b785472.svg";